export default {
  title: 'Układ zamówienia',
  form: {
    show_hero_image_with_offers: {
      label: 'Pokaż obraz główny z ofertami',
      description: 'Domyślnie dodanie obrazu oferty ukrywa obraz główny. Włącz tę opcję, aby wyświetlić oba.',
    },
  },
  buttons: {
    save: 'Zapisz',
  },
  toasts: {
    failed_to_save_changes: 'Nie udało się zapisać zmian',
    changes_got_saved: 'Zmiany zostały zapisane',
  },
};
